'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisibilityStatus = require('./components/VisibilityStatus.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VisibilityStatus).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-status/index.js
// module id = 1357
// module chunks = 0